module.exports = __webpack_public_path__ + "img/marker-yellow.48a4c4d2.png";